const initialState = () => ({
  downloading: false,
  query: {
    budgetLower: '',
    budgetUpper: '',
    companyName: '',
    displayColumn: [1, 2],
    displayData: [1, 2, 3, 4],
    displayDataSalary: '3',
    displayMonth: [],
    displayWeek: '4',
    employmentType: '1',
    industryCd: [],
    jobtypeCd: [],
    keyword: '',
    rangeType: '1',
    searchTargetAddress: '0',
    searchTargetKeyword: '0',
    searchCity: [],
    searchPrefecture: [],
  },
})

export default {
  namespaced: true,

  state: initialState(),
  getters: {
    apiQuery: state =>
      ({
        budgetLower: state.query.budgetLower,
        budgetUpper: state.query.budgetUpper,
        companyName: state.query.companyName,
        displayColumn: state.query.displayColumn.join(','),
        displayData: state.query.displayData.join(','),
        displayDataSalary: state.query.displayDataSalary,
        displayMonth: state.query.displayMonth.join(','),
        displayWeek: state.query.displayWeek,
        employmentType: state.query.employmentType,
        industryCd: state.query.industryCd.map(i => (i.value || i)).join(','),
        jobtypeCd: state.query.jobtypeCd.map(t => (t.value || t)).join(','),
        keyword: state.query.keyword,
        rangeType: state.query.rangeType,
        searchTargetAddress: state.query.searchTargetAddress,
        searchTargetKeyword: state.query.searchTargetKeyword,
        searchCity: state.query.searchCity.map(i => (i.value || i)).join(','),
        searchPrefecture: state.query.searchPrefecture.map(i => (i.value || i)).join(','),
      }),
  },
  mutations: {
    setDownloding: state => state.downloading = true,
    setDownloaded: state => state.downloading = false,
    budgetLower: (state, value) => state.query.budgetLower = value,
    budgetUpper: (state, value) => state.query.budgetUpper = value,
    companyName: (state, value) => state.query.companyName = value,
    displayColumn: (state, value) => state.query.displayColumn = value,
    displayData: (state, value) => state.query.displayData = value,
    displayDataSalary: (state, value) => state.query.displayDataSalary = value,
    displayMonth: (state, value) => state.query.displayMonth = value,
    displayWeek: (state, value) => state.query.displayWeek = value,
    employmentType: (state, value) => state.query.employmentType = value,
    industryCd: (state, value) => state.query.industryCd = value,
    jobtypeCd: (state, value) => state.query.jobtypeCd = value,
    keyword: (state, value) => state.query.keyword = value,
    rangeType: (state, value) => state.query.rangeType = value,
    searchTargetAddress: (state, value) => state.query.searchTargetAddress = value,
    searchTargetKeyword: (state, value) => state.query.searchTargetKeyword = value,
    searchCity: (state, value) => state.query.searchCity = value,
    searchPrefecture: (state, value) => state.query.searchPrefecture = value,
    resetState (state) {
      const initial = initialState()
      Object.keys(initial).forEach((key) => { state[key] = initial[key] })
    },
  },
  actions: {
    async reset ({ commit }) {
      commit('resetState')
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/searchAggregation.js